import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import type HyModel from '~/stores/models/base/Model'
import HyAutocomplete from './inputs/Autocomplete.vue'
import HyDatetime from './inputs/Datetime.vue'
import HyFile from './inputs/File.vue'
import HySelect from './inputs/Select.vue'
import HyString from './inputs/String.vue'
import HySwitch from './inputs/Switch.vue'
import HySwitches from './inputs/Switches.vue'
import HyTags from './inputs/Tags.vue'
import HyText from './inputs/Text.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
  field: {
    type: String,
    required: true
  },
  model: {
    type: Object,
    default: null
  }
},
  emits: ['input'],
  setup(__props, { emit: __emit }) {




// Source state from parent context (ex: Form.vue) and reactively update Input attributes
const disabled = inject('disabled', ref(false))
const display = inject('display', ref(false))

var attrs: any
// TODO: Why do we need to make attrs reactive here? (why do we need to use computed?)
// Use try-catch to handle the case where useAttrs() is not available
try {
  const rawAttrs = useAttrs()
  attrs = computed(() => {
    const combinedDisabled = disabled.value || !!rawAttrs.disabled
    const combinedDisplay = display.value || !!rawAttrs.display

    // Spread caller attrs first, then enforce combined disabled/display
    return {
      ...rawAttrs,
      disabled: combinedDisabled,
      display: combinedDisplay
    }
  })
} catch {
  attrs = computed(() => ({ disabled: disabled.value, display: display.value }))
}

const workingModel = __props.model ? ref(__props.model) : inject('model') as Ref<HyModel>
const fieldObject = computed(() => workingModel.value.field(__props.field))
const control = computed(() => fieldObject.value.control(attrs.value))
const inputModel = computed({
  get: () => workingModel.value[__props.field],
  set: (value) => workingModel.value[__props.field] = value
})
  
const emit = __emit
const handleUpdate = (updateEvent: any) => emit('input', updateEvent)

provide('input', {
  inputModel,
  control,
  field: fieldObject,
  handleUpdate
})


let inputComponent: any

if (fieldObject.value) {
  switch (fieldObject.value.type) {
    case 'image':
    case 'file':
      inputComponent = HyFile
      break
  
    case 'autocomplete':
    case 'location':
      inputComponent = HyAutocomplete
      break
  
    case 'date':
    case 'time':
    case 'datetime':
      inputComponent = HyDatetime
      break
  
    case 'select':
      inputComponent = HySelect
      break
  
    case 'switch':
      inputComponent = HySwitch
      break
  
    case 'switches':
      inputComponent = HySwitches
      break
  
    case 'tags':
      inputComponent = HyTags
      break
  
    case 'text':
      inputComponent = HyText
      break
  
    default:
      inputComponent = HyString
      break
  }
} else {
  console.error(`Unknown field: ${__props.field}`)
}


return (_ctx: any,_cache: any) => {
  return (_unref(control).display || _unref(attrs).display)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(fieldObject).display), 1))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(inputComponent)), {
        key: 1,
        field: _unref(fieldObject),
        class: "hy-input"
      }, null, 8, ["field"]))
}
}

})